<template>
    <div class="grid__container">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'GridContainer',
}
</script>